/**
 * La vertical clínica del negocio: veterinaria o salud humana.
 *
 * La fuente es `organization.humanHealth` del `/me` (identity#48/#53):
 * `true` = salud humana, `false` = veterinaria. Mientras identity no lo
 * exponga llega `undefined`, y ahí asumimos VETERINARIA — es lo que hace el
 * sidebar desde #59 para el label "Clínica"/"Veterinaria", y todos los
 * negocios clínicos de hoy son veterinarias.
 *
 * OJO: es la regla opuesta a la del muro clínico (`authz.ts`), que ante
 * `undefined` asume salud humana para PROTEGER PHI. Acá decidimos qué se
 * MUESTRA, no qué se PERMITE; equivocarse cuesta un tab de más, no un dato
 * expuesto. Por eso las dos reglas conviven y no se unifican.
 */
type UserWithOrganization = {
  organization?: { humanHealth?: boolean | null } | null;
} | null;

export function isVeterinary(user: UserWithOrganization | undefined): boolean {
  return !user?.organization?.humanHealth;
}

/** Label de la sección clínica del sidebar y de los breadcrumbs. */
export function clinicalSectionTitle(
  user: UserWithOrganization | undefined
): "Clínica" | "Veterinaria" {
  return isVeterinary(user) ? "Veterinaria" : "Clínica";
}
